import React, { useState } from 'react';
import { IconButton } from '@omilia/button';
import styled from 'styled-components';
import { colors } from '@omilia/theme';
import Dropdown, {
  DropdownTrigger,
  DropdownContent,
  DropdownItem,
} from '@omilia/dropdown-menu';

const SDropdownItem = styled(DropdownItem)`
  &&&& {
    color: ${colors.COLOR_GREY_800};
  }
`;

type Props = {
  items: { name: string; onClick: () => void }[];
};

const ListActionsMenu = ({ items = [] }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const clickHandler = (e: React.MouseEvent, func: () => void) => {
    e.stopPropagation();
    func();
  };

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <>
      <Dropdown isOpen={isOpen} onToggle={setIsOpen}>
        <DropdownTrigger onClick={e => clickHandler(e, toggleDropdown)}>
          <IconButton color="primary" glyph="options" size="16" />
        </DropdownTrigger>
        <DropdownContent position="right">
          {items.map(({ name, onClick }) => (
            <SDropdownItem
              key={name}
              onClick={(e, onToggle) =>
                clickHandler(e, () => {
                  onClick();
                  onToggle();
                })
              }
            >
              {name}
            </SDropdownItem>
          ))}
        </DropdownContent>
      </Dropdown>
    </>
  );
};

export default ListActionsMenu;
